
const httphost = 'https://www.zrypcgpj.cn/index.php' // 线上地址
// const httphost = 'http://rzyp63.hangdaokeji.com/index.php' // 本地地址
const httphosts = 'https://www.zrypcgpj.cn' // 图片本地地址

export {
  httphost,
  httphosts,
}